import { render } from "./Slides.vue?vue&type=template&id=927dbace&scoped=true&ts=true"
import script from "./Slides.vue?vue&type=script&lang=ts"
export * from "./Slides.vue?vue&type=script&lang=ts"

import "./Slides.vue?vue&type=style&index=0&id=927dbace&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-927dbace"]])

export default __exports__